export default "__VITE_ASSET__8uu4e22I__"